import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const pathCheck = route.data?.['checkPath'];

    if (!pathCheck) return true;

    const isAllowed = Array.isArray(pathCheck)
      ? pathCheck.some(path => this.authService.isAllowedToGrantSubsystemByPath(path))
      : this.authService.isAllowedToGrantSubsystemByPath(pathCheck);

    if (!isAllowed) {
      this.router.navigate(['/error'], {
        queryParams: {
          message: 'You do not have permission to access this page.'
        }
      });
    }

    return isAllowed;

  }
}
